import dynamic from 'next/dynamic';
import { useState, useRef, Fragment } from 'react';
import axios from 'axios';
import { useLocationState } from '../../context/location';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import Button from '../Button';
import Input from '../Input';
import Textarea from '../Textarea';
import { phoneToString, sleep } from '../../helpers';
import { submitClientRequest } from '../../helpers/clientRequest';
import FormAgreement from '../FormAgreement';

const Modal = dynamic(() => import('../Modal'));

const ObjectContactsMobile = ({ data }) => {
  const [isLoading, setIsLoading] = useState(false);
  const locationState = useLocationState();
  const { width } = useWindowDimensions();
  const [ownerPhone, setOwnerPhone] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isSubmited, setIsSubmited] = useState(false);
  const [clientName, setClientName] = useState('');
  const [clientPhone, setClientPhone] = useState('');
  const [clientComment, setClientComment] = useState('');
  const [agreeWithPolicy, setAgreeWithPolicy] = useState(false);
  const clientNameId = useRef();
  const clientPhoneId = useRef();

  const handlePhoneShowClick = async () => {
    if (ownerPhone) return;

    try {
      setIsLoading(true);
      await sleep(300);

      const response = await axios.get(
        process.env.NEXT_PUBLIC_API + `/contact/${data['sales-agent'].callId}`
      );

      if (!response.data || response.data.status !== 'ok') throw new Error(response.data.text);

      setIsLoading(false);
      setOwnerPhone(phoneToString(response.data.data.phone.toString()));
    } catch (error) {}
  };

  const handleFormSubmit = () => {
    clientNameId.current.setError(clientName.length <= 3);
    clientPhoneId.current.setError(clientPhone.length !== 11);

    if (clientName.length > 3 && clientPhone.length === 11 && agreeWithPolicy) {
      submitClientRequest({
        clientName,
        clientPhone: clientPhone,
        clientComment,
        pathName: window.location.pathname,
        whatComponent: 'ObjectContactsMobile',
        location: locationState.name,
        platform: 'web'
      }).then((isSubmitted) => {
        if (isSubmitted) setIsSubmited(true);
      });
    }
  };

  return width < 992 ? (
    <>
      <Modal
        title="Обратная связь"
        button={!isSubmited && 'Отправить'}
        buttonDisabled={!agreeWithPolicy}
        action={handleFormSubmit}
        visibility={isModalVisible}
        onClose={() => setIsModalVisible(false)}
      >
        {isSubmited ? (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Спасибо за вашу заявку. Мы скоро с Вами свяжемся!
            </div>
            <img
              src="/images/thumbUp.png"
              alt=""
              style={{ padding: 50, width: '100%', boxSizing: 'border-box' }}
            />
          </Fragment>
        ) : (
          <Fragment>
            <div style={{ marginBottom: 18 }}>
              Оставьте свои контактные данные и мы с Вами свяжемся в самые кратчайшие сроки, поможем
              решить все имеющиеся у Вас вопросы!
            </div>
            <Input
              title="Имя"
              inputs={[
                {
                  placeholder: 'Василий Петрович',
                  value: clientName,
                  type: 'text'
                }
              ]}
              isWrappedStyle
              ref={clientNameId}
              onChange={(v) => setClientName(v[0])}
            />
            <Input
              title="Телефон"
              inputs={[
                {
                  placeholder: locationState.phone,
                  value: clientPhone,
                  mask: 'phone',
                  type: 'tel'
                }
              ]}
              isWrappedStyle
              ref={clientPhoneId}
              onChange={(v) => setClientPhone(v[0])}
            />
            <Textarea
              title="Коммментарий"
              placeholder="Например, «Хочу получить консультацию перед продажей своей квартиры в городе»"
              autoHeight
              isWrappedStyle
              onChange={(v) => setClientComment(v)}
            />
            <FormAgreement onChange={setAgreeWithPolicy} />
          </Fragment>
        )}
      </Modal>
      <Button
        style={{ position: 'sticky', bottom: 12, zIndex: 5 }}
        onClick={handlePhoneShowClick}
        type="external"
        href={ownerPhone && 'tel:' + ownerPhone}
        loading={isLoading}
        color="green"
        fullWidth
      >
        {ownerPhone || 'Показать телефон'}
      </Button>
    </>
  ) : null;
};

export default ObjectContactsMobile;
